import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import image1 from '../../assets/test2primer1.png'
import Table from 'react-bootstrap/Table';

const div1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "inherit",
  padding: "3px"
}

const div2 = {
  width: "80%",
  height: "80%",
  background: "#fff",
  boxShadow: "15px 15px 25px #ccc",
  borderRadius: "15px"
}
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const centerText = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
class introIntTestTwo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      P1: '',
      P2: '',
      P3: ''
    }
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (e.target.name === 'P1' && e.target.value === '2') {
        Toast.fire({
          icon: 'success',
          title: 'To je tačan odgovor'
        })
      } else if (e.target.name === 'P2' && e.target.value === '1') {
        Toast.fire({
          icon: 'success',
          title: 'To je tačan odgovor'
        })
      } else if (e.target.name === 'P3' && e.target.value === '1') {
        Toast.fire({
          icon: 'success',
          title: 'To je tačan odgovor'
        })
      }
    });
  }
  render() {
    return (
      <div className="Content">
        <div style={div1}>
          <div style={div2}>
            <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
              <div style={{ padding: "16px 0", textAlign: "left" }}>
                <br /><br />
                <div style={centerText}>Zdravo {this.props.auth.user.name},</div>
                <br />
                <br />
                U drugom delu testa pred Vama će se nalaziti parovi reči.
                <br />
                <br />
                Ukoliko se iz nekih nepredviđenih razloga (zatvaranje stranice, izlazak iz pretraživača, osvežavanje stranice testa) izlogujete sa testa, javite se na e-mail adresu: {this.props.auth.user.company === "Group" ? "tanja.petrovic@galeb.com" : "jovana.markovic@galeb.com"}.
                <br />
                <br />
                Vaš zadatak je da zaključite da li dve reči u paru imaju istoili suprotno značenje.
                <br />
                Ukoliko imaju isto značenje, potrebno je da obeležite broj 1,a ukoliko imaju suprotno značenje potrebno je da obeležite broj 2.
                <br />
                Vremensko ograničenje je 2 minuta, nakon čega će se Vaši odgovori automatski sačuvati, bez obzira da li ste odgovorili na sva pitanja.
                <br /><br />
                <div style={centerText}>Primeri:</div>
                <br />
                <div style={centerText}><img src={image1} alt='imageExample'/></div>
                <br />
                <div style={centerText}>Reči dobar i rđav imaju suprotno značenje, zbog čega je kao tačno rešenje obeležena broj 1.</div>
                <br />
                <div style={centerText}>Reči malen i sićušan imaju isto značenje zbog čega je kao tačno rešenje obeležen broj 2</div>
                <br />
                <div style={centerText}>Pre nego što pređete na test, uradite tri zadatka za vežbu.</div>
                <br />
                <div style={centerText}>
                  <Table striped bordered hover variant="grey" style={{ width: '45%' }}>
                    <tbody>
                      <tr>
                        <td>Par</td><td>Isto</td><td>Suprotno</td>
                      </tr>
                      <tr>
                        <td>Radost - Žalost</td>
                        <td>
                          <div className="form-check">
                            <label style={{ 'fontSize': '15px' }}>
                              <input
                                onChange={this.onChange}
                                type="radio"
                                name="P1"
                                value="1"
                                className="form-check-input"
                              /> 1 </label>
                          </div>
                        </td>
                        <td>
                          <div className="form-check">
                            <label style={{ 'fontSize': '15px' }}>
                              <input
                                onChange={this.onChange}
                                type="radio"
                                name="P1"
                                value="2"
                                className="form-check-input"
                              /> 2 </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Tuga - Bol</td>
                        <td>
                          <div className="form-check">
                            <label style={{ 'fontSize': '15px' }}>
                              <input
                                onChange={this.onChange}
                                type="radio"
                                name="P2"
                                value="1"
                                className="form-check-input"
                              /> 1 </label>
                          </div>
                        </td>
                        <td>
                          <div className="form-check">
                            <label style={{ 'fontSize': '15px' }}>
                              <input
                                onChange={this.onChange}
                                type="radio"
                                name="P2"
                                value="2"
                                className="form-check-input"
                              /> 2 </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Veselje - Radost</td>
                        <td>
                          <div className="form-check">
                            <label style={{ 'fontSize': '15px' }}>
                              <input
                                onChange={this.onChange}
                                type="radio"
                                name="P3"
                                value="1"
                                className="form-check-input"
                              /> 1 </label>
                          </div>
                        </td>
                        <td>
                          <div className="form-check">
                            <label style={{ 'fontSize': '15px' }}>
                              <input
                                onChange={this.onChange}
                                type="radio"
                                name="P3"
                                value="2"
                                className="form-check-input"
                              /> 2 </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div style={centerText}><Link to="/intTestTwo" className="btn btn-info btn-fill col-md-2" >Pređi na test</Link></div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps,
)(introIntTestTwo);